import React, { useEffect } from "react";
import { Link } from "react-router";
import { browserHistory } from "react-router";
import { Auth } from "aws-amplify";

import { auth } from "../../../firebase";

// import { ConfirmSignUp } from "aws-amplify-react";
import "./Signup.css";
import { Button, Modal } from "react-bootstrap";
import { resendConfirmationCode, signUpNormal } from "../../../utils/utils";
import SigninBlue from "../../../assets/app/img/logo-signin-blue.png";
import {
  trackSignupButtonClickEvent,
  trackSignupPageViewEvent,
} from "../../../utils/facebookPixelEvents";

import { Helmet } from "react-helmet";

import {
  checkIfBlogTeam,
  currentYear,
  getUserEmail,
  getUserGroup,
  isLoggedIn,
} from "../../../utils/utils";

import { getUserMetaData } from "../../../firestoreQueries";
import SkeletonLoader from "../../Skeleton/SkeletonLoader";

export default function SignUp() {
  const [loginStatus, setLoginStatus] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(true);
  // const browserHistory = useHistory();
  useEffect(() => {
    document.title = "Sign Up";
  }, []);

  useEffect(() => {

    const checkLoginStatus = async () => {
      try {
        const resp = await isLoggedIn("signup");
        console.log("isLoggedIn Signup:: " + resp);
        const email = await getUserEmail()
        const userMetadata = await getUserMetaData(email);
        console.log("user metadata signup", userMetadata);
        // // check if there is a userMetadata
        // if (userMetadata.exists) {
        //   console.log("User Metadata:: ", userMetadata.data());
        // } else {
        //   const metaDataToAdd = {
        //     userID: auth.currentUser.uid,
        //     email: auth.currentUser.email,
        //     preferences: {
        //       web: null,
        //       android: null,
        //     }
        //   }
        //   console.log("User Metadata to add:: ", metaDataToAdd);
        //   const metadataResp = insertUserMetaData(metaDataToAdd);
        //   console.log("User Metadata added:: ", metadataResp);
        // }

        setLoginStatus(resp === true);
        setShowLoader(false)
      } catch (error) {
        console.log("Sigup Component::: Not Logged in");
        setLoginStatus(false);
        setShowLoader(false);
      }
    };

    checkLoginStatus()

  }, [])
  const initialFormData = Object.freeze({
    email: "",
    password: "",
    repassword: "",
    // username: "",
  });

  const [formData, updateFormData] = React.useState(initialFormData);
  const [authCode, setAuthCode] = React.useState();
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const closeModal = () => {
    setIsOpenModal(false);
  };
  const handleChange = (e) => {
    updateFormData({
      ...formData,

      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });
  };
  const handleChangeAuthCode = (e) => {
    setAuthCode(e.target.value.trim());
  };

  async function signUp(email, password) {
    try {
      auth
        .createUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          browserHistory.push("/app");
          // ...
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          // ..
        });
      // const { user } = await Auth.signUp({
      //   username: email,
      //   password,
      // });
      // setUser(user);
      // openModal();
      // console.log(user);
    } catch (error) {
      console.log("error signing up:", error);
      if (error.code === "InvalidPasswordException") {
        const message = "Password should be atleast 8 characters long";
        alert(message);
      } else {
        alert(error.message);
      }
    }
  }

  const handleSubmit = (e) => {
    if (process.env.REACT_APP_ENV === "production") {
      trackSignupButtonClickEvent();
    }

    e.preventDefault();
    console.log(formData);
    // ... submit to API or something
    if (formData.email.length === 0) {
      alert("Username cannot be empty!");
    }
    if (formData.password !== formData.repassword) {
      alert("Passwords dont match");
    } else {
      console.log("Yay");
      signUp(formData.email, formData.password);
    }
  };

  async function confirmSignUp(username, code) {
    try {
      await Auth.confirmSignUp(username, code);
    } catch (error) {
      console.log("error confirming sign up", error);
      alert(error.message);
    }
  }

  const handleSubmitConfirmSignUp = (e) => {
    e.preventDefault();
    console.log(authCode);
    // ... submit to API or something
    if (authCode === 0) {
      alert("Auth Code cannot be empty!");
    } else {
      console.log("Yay");
      confirmSignUp(formData.email, authCode)
        .then((resp) => {
          console.log(resp);
          signUpNormal(formData.email, formData.password)
            .then((resp) => {
              browserHistory.push("/app");
            })
            .catch((err) => {
              alert("Something went wrong");
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleResendVerificationCode = (e) => {
    e.preventDefault();
    const resp = resendConfirmationCode(formData.email);
    if (resp === true) {
      alert("Verification code sent again successfully");
    } else {
      alert("Something went wrong... Please try again later");
    }
  };

  const goHome = () => {
    window.location.href = "/";
  };

  function redirect() {
    console.log("redirect called");
    browserHistory.push("/app");
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://spontasy.com/signup" />
      </Helmet>
      {process.env.REACT_APP_ENV === "production"
        ? trackSignupPageViewEvent()
        : null}
      {showLoader ? (
        <SkeletonLoader />
      ) : loginStatus ? (
          redirect()
        ) : 
      <div className="signup__main">
        <div className="card bg-dark col-lg-4 col-md-6 col-sm-12">
          <div className="card-body">
            <div className="text-center">
              <img
                className="signup__logo"
                // src="/res/spordia_logo.png"
                src={SigninBlue}
                alt=""
                role="button"
                onClick={goHome}
              />
            </div>

            <h2 className="card-title text-center text-white mb-2">Signup</h2>
            <form action="">
              <div class="form-group">
                {/* <input
                class="form-control form-control-lg mb-3 bg-dark text-white"
                type="text"
                placeholder="Username"
                name="username"
                onChange={handleChange}
              ></input> */}
                <input
                  class="form-control form-control-lg mb-3 bg-dark text-white"
                  type="email"
                  placeholder="Email"
                  name="email"
                  onChange={handleChange}
                ></input>
                <input
                  class="form-control form-control-lg mb-3 bg-dark text-white"
                  type="password"
                  placeholder="Password"
                  name="password"
                  onChange={handleChange}
                ></input>
                <input
                  class="form-control form-control-lg mb-3 bg-dark text-white"
                  type="password"
                  placeholder="Re enter Password"
                  name="repassword"
                  onChange={handleChange}
                ></input>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  class="btn btn-primary btn-lg btn-block"
                >
                  Sign Up
                </button>
                <Link to={"/app/signin"} className="text-white text-center m-2">
                  Already a member?{" "}
                  <span className="text-primary" style={{ cursor: "pointer" }}>
                    Sign In
                  </span>
                </Link>
              </div>
            </form>
            <p className="text-center text-white">
              <small>© All rights reserved. Spordia {currentYear}</small>
            </p>
          </div>

          <Modal
            show={isOpenModal}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton className="bg-dark text-white">
              <Modal.Title className="model-header">
                Verify your account
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark">
              <input
                class="form-control form-control-lg mt-3 mb-3 bg-dark text-white"
                type="text"
                placeholder="Verification Code"
                name="authcode"
                onChange={handleChangeAuthCode}
              ></input>
            </Modal.Body>
            <Modal.Footer className="bg-dark">
              <Button
                variant="secondary"
                onClick={handleResendVerificationCode}
                className="btn btn-primary btn-lg"
              >
                Resend Verification Code
              </Button>
              <Button
                variant="secondary"
                onClick={handleSubmitConfirmSignUp}
                className="btn btn-primary btn-lg"
              >
                Verify
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      } 
    </>
  );
}
